import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_ADD_AFFILIATE_PROGRAMS,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_AFFILIATE_PROGRAMS:
      return { ...state, ...action.payload.affiliatePrograms };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  errors,
});
